<template>
  <div class="status-page">
    <div class="top-nav"><h1 class="title">申请加入联盟</h1></div>
    <div class="status-card">
      <img src="@/assets/check.png" alt="等待审核">
      <h2>申请已提交</h2>
      <p>{{ memberType === 'PERSONAL' ? '个人用户资料正在审核中' : '企业资料正在审核中' }}</p>
      <span>审核结果会自动同步，请耐心等待</span>
      <el-button :loading="refreshing" @click="syncStatus">刷新审核状态</el-button>
    </div>
  </div>
</template>

<script>
import { normalizeMemberInfo, getApplyRoute } from '@/utils/memberStatus'

export default {
  name: 'ApplyWait',
  data() {
    return {
      memberType: '',
      refreshing: false,
      timer: null
    }
  },
  mounted() {
    this.memberType = normalizeMemberInfo(JSON.parse(sessionStorage.getItem('userInfo') || '{}')).memberType
    this.syncStatus()
    this.timer = setInterval(this.syncStatus, 10000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    syncStatus() {
      if (this.refreshing) return
      this.refreshing = true
      this.$ajax.get('/api/user/current').then(res => {
        if (res.data.code !== 200) return
        const user = res.data.data || {}
        this.memberType = normalizeMemberInfo(user).memberType
        sessionStorage.setItem('userInfo', JSON.stringify(user))
        const target = getApplyRoute(user)
        if (target && target !== '/apply/wait') this.$router.replace(target)
      }).finally(() => {
        this.refreshing = false
      })
    }
  }
}
</script>

<style scoped>
.status-page { min-height:100vh; background:#f8fafc; padding-bottom:80px; }
.top-nav { display:flex; align-items:center; padding:16px 20px; background:#fff; }
.title { margin:0 auto; color:#1a1a1a; font-size:18px; font-weight:600; }
.status-card { margin:28px 20px; padding:46px 24px; border-radius:16px; background:#fff; text-align:center; box-shadow:0 2px 12px rgba(31,45,61,.05); }
.status-card img { width:120px; height:120px; object-fit:contain; }
.status-card h2 { margin:22px 0 10px; color:#1a1a1a; font-size:20px; }
.status-card p { margin:0 0 8px; color:#333; font-size:14px; }
.status-card span { display:block; margin-bottom:24px; color:#909399; font-size:12px; }
.status-card >>> .el-button { min-width:140px; border-radius:9px; }
</style>



// WEBPACK FOOTER //
// src/components/menu/join/wait.vue